import { Directive, ElementRef, Input, SimpleChanges } from '@angular/core';
import { FailureCode } from 'src/app/core/api/models';

@Directive({
  selector: '[failureCodeIcon]',
  standalone: true,
})
export class FailureCodeIconDirective {

  @Input('failureCodeIcon') type: FailureCode;

  constructor(private element: ElementRef<HTMLElement>) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.element.nativeElement.className = this.getCssClassList();
  }

  getCssClassList(): string {
    let classList = 'tw-text-sm mdi-22px tw-font-bold ';
    switch (this.type) {
      case FailureCode.NotFailure:
        classList += ' mdi mdi-check text-success';
        break;
      // case FailureCode.OperatorNumberCountIsNull:
      //   classList += " mdi mdi-account-multiple-remove-outline text-danger";
      //   break;
      case FailureCode.DailySendLimit:
      case FailureCode.MonthlySendLimit:
        classList += 'mdi mdi-calendar-lock-outline ';
        break;
      case FailureCode.UserCreditNotEnough:
      case FailureCode.AdminCreditNotEnough:
      case FailureCode.OrganizationCreditNotEnough:
        classList += 'mdi mdi-credit-card-remove-outline text-danger ';
        break;
      case FailureCode.PrivateNumberIsInactive:
      case FailureCode.PrivateNumberIsExpired:
      case FailureCode.PrivateNumberNotValid:
      case FailureCode.PrivateNumberIsDeleted:
      case FailureCode.FileIsEmpty:
        classList += 'mdi mdi-sim-off-outline text-orange ';
        break;
      case FailureCode.AllRecipientIsBlackList:
        classList += 'mdi mdi-account-cancel-outline text-orange ';
        break;
      // case FailureCode.UserIsInactive:
      case FailureCode.AdminIsInactive:
        classList += 'mdi mdi-account-off-outline text-danger ';
        break;
      case FailureCode.UserIsExpired:
        classList += 'mdi mdi-account-alert-outline text-danger ';
        break;
      case FailureCode.UserIsExpired:
        classList += 'mdi mdi-account-alert-outline text-danger ';
        break;
      case FailureCode.SmsTextIsFilter:
        classList += 'mdi mdi-cancel text-danger ';
        break;

      default:
        classList += ' mdi mdi-alert-circle-outline text-danger';
        break;
    }
    return classList;
  }
}
